import { Component } from 'react'
import styles from '~/styles/dealers.collapsableList_.module.css'
import types from '~/types/ordersPage.ts'

export default class CollapsableList extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}

	constructor(props) {
		super(props)
		let state = {}
		Object.keys(this.props.dealersObject).forEach(dealerId => {
			const dealer = this.props.dealersObject[dealerId]
			if (dealer.level > 1) {
				state['isHiddenByCollapse' + dealer.id] = true
				state['isCollapsed' + dealer.id] = true
			}
		})
		this._currentDealer = this.props.dealersObject?.[this.props.currentDealer.id] || {}
		state['isCollapsed' + this._currentDealer.id] = true
		this._currentDealer.allParents?.forEach(dealerId => {
			const parent = this.props.dealersObject?.[dealerId] || {}
			state['isHiddenByCollapse' + parent.id] = false
			state['isCollapsed' + parent.id] = false
			parent.ownChildren?.forEach(id => {
				state['isHiddenByCollapse' + id] = false
			})
		})
		this.state = state
	}

	public render(): JSX.Element {
		return (
			<div
				className={styles.main}
				clicklabel={this.props.clickLabel || null}
			>
				{this._getDealers()}
			</div>
		)
	}

	public componentDidMount() {
		if (this.props.hasOwnProperty('search')) {
			this._search()
		}
	}

	public componentDidUpdate(prevProps, prevState) {
		if (prevProps.search !== this.props.search) {
			if (this.props.hasOwnProperty('search')) {
				this._search()
			}
		}
	}

	private _search(): void {
		let objectToState = {}
		const search = (this.props.search || '').toLowerCase().trim()
		Object.keys(this.props.dealersObject).forEach((dealerId, i) => {
			const dealer = this.props.dealersObject[dealerId]
			if (search) {
				objectToState['isCollapsedBySearch' + dealer.id] = true
				objectToState['isHiddenBySearch' + dealer.id] = true
				if (dealer.name.toLowerCase().includes(search)) {
					objectToState['isHiddenBySearch' + dealer.id] = false
					objectToState['isHiddenByCollapse' + dealer.id] = false
					dealer.allParents?.forEach(dealerId => {
						objectToState['isHiddenBySearch' + dealerId] = false
						objectToState['isHiddenByCollapse' + dealerId] = false
						objectToState['isCollapsedBySearch' + dealerId] = false
						objectToState['isCollapsed' + dealerId] = false
					})
				}
			} else {
				if (dealer.level === 1) {
					objectToState['isCollapsedBySearch' + dealer.id] = false
					objectToState['isHiddenBySearch' + dealer.id] = false
				}
				if (dealer.allChildren?.length) {
					objectToState['isCollapsedBySearch' + dealer.id] = true
					objectToState['isCollapsed' + dealer.id] = true
					dealer.allChildren?.forEach(id => {
						if (!this.props.currentDealer?.allowedDealers.includes(id)) {
							objectToState['isHiddenBySearch' + id] = true
							objectToState['isHiddenByCollapse' + id] = true
						}
						const child = this.props.dealersObject?.[id] || {}
						if (child.ownChildren?.length) {
							objectToState['isCollapsedBySearch' + child.id] = true
							objectToState['isCollapsed' + child.id] = true
						}
					})
				}
				if (dealer.id === this._currentDealer.id && !this.props.showNextLevel) {
					this._currentDealer.allParents?.forEach(dealerId => {
						const parent = this.props.dealersObject?.[dealerId] || {}
						objectToState['isHiddenBySearch' + parent.id] = false
						objectToState['isHiddenByCollapse' + parent.id] = false
						objectToState['isCollapsedBySearch' + parent.id] = false
						objectToState['isCollapsed' + parent.id] = false
						if (parent.level === (this._currentDealer.level - 1)) {
							parent.ownChildren?.forEach(id => {
								if (!this.props.currentDealer?.allowedDealers.includes(id)) {
									objectToState['isHiddenBySearch' + id] = true
									objectToState['isHiddenByCollapse' + id] = true
								}
							})
						}
					})
					objectToState['isHiddenBySearch' + this._currentDealer.id] = false
					objectToState['isHiddenByCollapse' + this._currentDealer.id] = false
					objectToState['isCollapsedBySearch' + this._currentDealer.id] = true
					objectToState['isCollapsed' + this._currentDealer.id] = true
					this._currentDealer.ownChildren?.forEach(dealerId => {
						const ownChild = this.props.dealersObject?.[dealerId] || {}
						objectToState['isHiddenBySearch' + ownChild.id] = false
						objectToState['isHiddenByCollapse' + ownChild.id] = false
						objectToState['isCollapsedBySearch' + ownChild.id] = true
						objectToState['isCollapsed' + ownChild.id] = true
					})
				}
				if (this.props.showNextLevel) {
					const minLevel = this._currentDealer.minLevel || this._currentDealer.level
					if (dealer.level === minLevel) {
						objectToState['isHiddenBySearch' + dealer.id] = false
						objectToState['isHiddenByCollapse' + dealer.id] = false
						objectToState['isCollapsedBySearch' + dealer.id] = false
						objectToState['isCollapsed' + dealer.id] = false
					} else if (dealer.level === (minLevel + 1)) {
						objectToState['isHiddenBySearch' + dealer.id] = false
						objectToState['isHiddenByCollapse' + dealer.id] = false
					}
				}
			}
		})
		this.setState(objectToState)
	}	

	private _getDealers(): Array<JSX.Element> {
		const dealersJsx = []
		if (this.props.dealersObject) {
			let currentModuleSorting = 0
			Object.keys(this.props.dealersObject).forEach((dealerId, i) => {
				const dealer = this.props.dealersObject[dealerId]
				let isModuleBorder = false
				if (currentModuleSorting !== dealer.moduleSorting) {
					currentModuleSorting = dealer.moduleSorting
					isModuleBorder = true
				}
				dealersJsx.push(this._getDealer(dealer, i ? isModuleBorder : false))
			})
		}
		return dealersJsx
	}

	private _getDealer(dealer, isModuleBorder: boolean): JSX.Element {
		if (dealer) {
			let level = dealer.level
			let className = styles.dealer
			if (isModuleBorder) {
				className += ' ' + styles.isModuleBorder
			}
			const isHiddenByCollapse = this.state['isHiddenByCollapse' + dealer.id]
			const isHiddenBySearch = this.state['isHiddenBySearch' + dealer.id]
			if (isHiddenByCollapse || isHiddenBySearch) {
				className += ' ' + styles.isHidden
			}
			const allowedDealers = dealer?.allowedDealers || []
			if (!this.props.preventNotAllowed) {
				if (!allowedDealers.includes(dealer.id)) {
					if (!(this.props.showNextLevel && this._currentDealer.id === dealer.id)) {
						className += ' ' + styles.isDisabled
					}
				}
			}
			if (this._currentDealer.id === dealer.id) {
				if (!this.props.showCurrent) {
					className += ' ' + styles.isCurrentDealer
				}
				if (dealer.level === 1 && !dealer.ownChildren?.length) {
					if (!this.props.showNextLevel) {
						className += ' ' + styles.isHidden
					}
				}
			}
			if (dealer.ownChildren?.length && level) {
				level--
			}
			let dealerJSX = (
				<div
					key={dealer.id}
					className={className}
				>
					{this._getShifts(level)}
					{this._getCollapsableSign(dealer)}
					<div
						key={dealer.id}
						className={styles.name}
						onClick={this._onDealer.bind(this, dealer)}
					>
						{dealer.name}
					</div>
				</div>
			)
			return dealerJSX
		} else {
			return null
		}
	}

	private _getShifts(amount: number): JSX.Element {
		let shifts = []
		for (let i = 0; i < amount; i++) {
			shifts.push((
				<div
					key={'shift' + i}
					className={styles.shift}
				/>
			))
		}
		return shifts
	}

	private _getCollapsableSign(dealer): JSX.Element {
		let collapsable = null 
		if (dealer.ownChildren?.length) {
			let isCollapsable = false
			if (dealer.isManager) {
				isCollapsable = true
			} else {
				dealer.ownChildren.some(childId => {
					if (this.props.dealersObject[childId]) {
						if (!Object.hasOwnProperty(dealer.allowedDealers)) {
							isCollapsable = true
							return true
						} else if ((dealer.allowedDealers || []).includes(childId)) {
		 					isCollapsable = true
		 					return true
						}
					}
				})
			}
			if (isCollapsable) {
				let className = styles.collapseable
				let arrow = '\u2304'
				if (this.state['isCollapsed' + dealer.id]) {
					className += ' ' + styles.isCollapsed
					// arrow = '\u2304'
					arrow = '\u203A'
				}
				collapsable = (
					<div
						className={className}
						onClick={this._onCollapse.bind(this, dealer)}
						clicklabel={this.props.clickLabel || null}
					>
						<div>
							{arrow}
						</div>
					</div>
				)
			} else {
				collapsable = this._getShifts(1)
			}
		}
		return collapsable
	}

	private _onCollapse(dealer): void {
		let objectToState = {}
		let isCollapsed = !(this.state['isCollapsed' + dealer.id])
		objectToState['isCollapsed' + dealer.id] = isCollapsed
		if (isCollapsed) {
			dealer.allChildren?.forEach(dealerId => {
				objectToState['isHiddenByCollapse' + dealerId] = isCollapsed
				const subDealer = this.props.dealersObject[dealerId]
				if (subDealer?.ownChildren?.length) {
					objectToState['isCollapsed' + dealerId] = isCollapsed
				}
			})
		} else {
			dealer.ownChildren?.forEach(dealerId => {
				objectToState['isHiddenByCollapse' + dealerId] = isCollapsed
				objectToState['isHiddenBySearch' + dealerId] = false
			})
		}
		this.setState(objectToState)
	}

	private _onDealer(dealer): void {
		if (this.props.onDealerChange) {
			let isCurrentDealer = (this._currentDealer.id === dealer.id)
			if (this.props.showNextLevel) {
				isCurrentDealer = false
			}
			let isNotAllowed = true
			const allowedDealers = dealer?.allowedDealers || []
			if (allowedDealers.includes(dealer.id)) {
				isNotAllowed = false
			}
			if (!(isCurrentDealer || isNotAllowed) || this.props.preventNotAllowed) {
				this.props.onDealerChange(dealer.id, dealer)
			}
		}
	}
}